<template>
  <v-layout id="step-2-box" align-center column>
    <component :is="currentTabComponent" />
  </v-layout>
</template>

<script>
import TextContent from '@/components/Wrappers/Text/Text';
import SmartAgentFormStep2 from '@/components/Smart_Agent/Smart_Agent_Form/SmartAgentFormStep2';
import AgentHeader from '@/components/Smart_Agent/Header/AgentHeader';
import { mapGetters } from 'vuex';
import gtm from '@/lib/gtm';

export default {
  components: {
    TextContent,
    SmartAgentFormStep2,
    AgentHeader,
  },
  computed: {
    ...mapGetters(['isLogged', 'isRegisteredSmartAlerts']),
  },

  mounted() {
    if (this.isLogged && !this.isRegisteredSmartAlerts) {
      /** Goal 5 event #2 - if user logged && !registered to smartalert */
      gtm({
        page: '/smartalerts/step2',
        event: 'smartalert',
      });
    }
  },

  data() {
    return {
      title: 'סימון העדפות',
      text: 'בחירת קטגוריות ותחומים',
      currentTabComponent: 'SmartAgentFormStep2',
    };
  },

  methods: {
    opneLogin() {
      document.querySelector('.login-btn').click();
    },
  },
};
</script>

<style lang="scss" scoped>
#step-2-box {
  max-width: 1260px;
  margin: 0 auto;
}

.content-alignment {
  display: flex;
  flex-direction: column;
  text-align: center;
}
</style>
